// /w/:wid/reports/:id? — on a phone the inbox and a report are separate screens (ReportsInbox, ReportView); on a tablet
// or PC with the room (layout.split) they sit side by side: the inbox on the left, the open report on the right.
import { useParams } from "react-router-dom";
import { WorldPage } from "@/app/WorldPage";
import { art } from "@/kit/art";
import { useLayout } from "@/state/layout";
import { Inbox, ReportsInbox } from "./ReportsInbox";
import { Report, ReportView } from "./ReportView";

export function Reports() {
  const { id } = useParams();
  const { split } = useLayout();
  if (!split) return id ? <ReportView /> : <ReportsInbox />;
  return (
    <WorldPage layout="split">
      <div className="split">
        <div className="split-list"><Inbox /></div>
        <div className="split-item">
          {id ? <Report key={id} /> : <SplitNone img={art.social.seal("victory")} text="Choose a report from the list." />}
        </div>
      </div>
    </WorldPage>
  );
}

/** The right-hand pane before anything is chosen. */
export const SplitNone = ({ img, text }: { img?: string; text: string }) => (
  <div className="split-none card frame">
    {img && <img src={img} alt="" />}
    <p>{text}</p>
  </div>
);
